export class UntrustDevicesRequestModel {
  constructor(public devices: string[]) {}
}
